<div class="speech-bubble" [class.bubbleInBubble]="bubbleInBubble" [class.right]="right" [class.reply]="reply">
  <!-- Board and Card Context (only show if not in a reply or bubble-in-bubble and if we have the info) -->
  <div class="context-info" *ngIf="!bubbleInBubble && !reply && chat.cardName && !embedded" (click)="navigateToCard()">
    <span class="board-name" *ngIf="chat.boardName">{{chat.boardName}}</span>
    <span *ngIf="chat.boardName">&raquo;</span>
    <span class="card-name">{{chat.cardName}}</span>
    <span class="card-lane" *ngIf="cardLane">[{{cardLane}}]</span>
    <mat-icon class="open-icon" matTooltip="Open Card">open_in_new</mat-icon>
  </div>

  <div class="heading">
    <div class="user" title="{{chat.senderName}}">{{ chat.senderName }}</div>
    <div class="time">{{chat.createdAt | chatTimeAgo }}</div>
    
    <div class="close-button">
      @if (chat.read) {
        <mat-icon class="read" matTooltip="Read">check</mat-icon>
      }
      @if (!bubbleInBubble && !reply) {
        <mat-icon (click)="replyClicked.emit()" matTooltip="Reply">reply</mat-icon>
      }
      @if (reply) {
        <mat-icon class="close" (click)="close.emit()" matTooltip="Close">close</mat-icon>
      }
      @if (right) {
        <mat-icon (click)="delete()" matTooltip="Delete">delete</mat-icon>
      }
    </div>
  </div>

  <div class="bubble" [class.bubbleInBubble]="bubbleInBubble">
    @if (chat.replyTo) {
      <div class="reply">
        <app-speech-bubble
          [bubbleInBubble]="true"
          [reply]="true"
          [chat]="chat.replyTo"
          [embedded]="embedded"
          (close)="close.emit()">
        </app-speech-bubble>
      </div>
    }

    @if (chat.file) {
      <div class="image">
        @if (isImageUrl(chat.file)) {
          <img [src]="chat.file" alt="" />
        }
        @if (!isImageUrl(chat.file)) {
          <a mat-raised-button [href]="chat.file" target="_blank">
            {{ extractFileName(chat.file) }}
          </a>
        }
      </div>
    }
    
    <div class="message-content" [innerHtml]="chat | transformMessage"></div>
    
    <!-- Card references from message -->
    @if (chat.cardsMentioned && chat.cardsMentioned.length > 0) {
      <div class="card-references">
        <div class="reference-title">Referenced Cards:</div>
        <div class="reference-list">
          @for (cardRef of chat.cardsMentioned; track cardRef) {
            <a class="card-reference" [routerLink]="['/' + cardRef.link]" matTooltip="Open this card">
              <mat-icon class="card-icon">sticky_note_2</mat-icon>
              <span class="card-code">{{cardRef.code}}</span>
              <span class="card-title">{{cardRef.title}}</span>
            </a>
          }
        </div>
      </div>
    }
    
    <!-- Additional content provided via ng-content -->
    <ng-content></ng-content>
  </div>
</div>
